export const BASE_URL = 'https://api.sulemp.com/api';
// export const BASE_URL = 'https://testapi.sulemp.com/api';
// export const BASE_URL = 'http://localhost:5000/api';
// export const BASE_URL = 'http://192.168.15.27/api/api';